module.exports = __webpack_public_path__ + "img/thinking_in_system.adc84f4a.jpg";